import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircleIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Apps Gratuitas (Credit Karma)',
    desc: 'Te dan consejos genéricos pero no borran la información negativa real que te está hundiendo.'
  }, {
    title: 'Llamar a los Cobradores',
    desc: "Para 'explicar tu situación' solo reinicia el tiempo legal de la deuda y les da más poder para acosarte."
  }, {
    title: 'Agencias de Reparación ($2,000+)',
    desc: 'A menudo termina en pérdida de dinero con cartas genéricas que tú mismo podrías haber impreso.'
  }];
  return <section className="py-24 bg-cream text-text-dark" data-id="element-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-16" data-id="element-17">
            Lo que ya intentaste...{' '}
            <span className="italic text-text-muted" data-id="element-18">
              y por qué no funcionó
            </span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-19">
          {failures.map((item, index) => <FadeIn key={index} delay={0.2 * (index + 1)} data-id="element-20">
              <div className="bg-white p-8 rounded-xl shadow-sm border border-cream-dark h-full flex flex-col items-center text-center" data-id="element-21">
                <XCircleIcon className="w-12 h-12 text-red-500 mb-6" data-id="element-22" />
                <h3 className="text-xl font-bold text-navy mb-4 font-serif" data-id="element-23">
                  {item.title}
                </h3>
                <p className="text-text-muted font-sans leading-relaxed" data-id="element-24">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}